<template>
  <transition name="pop-fade">
    <div class="pop-backdrop">

      <div class="splash-container" v-show="pendingRequest">
        <div class="splash">
          <div class="splash-content" />
        </div>
      </div>

      <div class="pop" v-show="!pendingRequest">
        <header class="pop-header">
          <div name="header">
            Update Trading View Username
          </div>
        </header>
        <section class="pop-body">
          <div name="body">
            <input 
              class="pop-input"
              placeholder="Enter your username"
              v-model="username"
            >
          </div>
        </section>
        <footer class="pop-footer">
            <div name="footer">

              <button
                type="button"
                class="btn-confirm"
                @click="confirm"
              >
                Confirm
              </button>

              <button
                type="button"
                class="btn-cancel"
                @click="close"
              >
                Cancel
            </button>
          </div>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import db from '../../database/index';
const collection = db.collection('users');

  export default {
    name: 'TradingViewpop',
    props: {
      discord: {
        type: Object
      }
    },
    data() {
      return {
        username: '',
        pendingRequest: false
      }
    },
    methods: {
      async confirm() {
        // Render splash
        this.pendingRequest = true;

        await collection.where('discordId', '==', this.discord.id).get()
          .then(snap => snap.forEach(async doc => {
            await collection.doc(doc.id).update({ tradingView: this.username })
          }))

        this.$emit('newUsername', this.username);
        this.pendingRequest = false;
      },
      close() {
        this.username = '';
        this.$emit('close');
      }
    },
  };
</script>

<style scoped>
  .pop-backdrop {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
  }

  .pop {
    background: #36393f;
    color: #f8f8f8;
    font-size: 14px;
    border-radius: 8px;
    box-shadow: 0.5px 0.5px 5px 0.25px #656769;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }

  .pop-header,
  .pop-footer {
    padding: 15px;
    display: flex;
  }

  .pop-header {
    justify-content: center;
    font-size: 1.30em;
    text-transform: uppercase;
    font-weight: 800;
  }

  .pop-footer {
    justify-content: space-evenly;
    margin-bottom: 10px;
  }

  .pop-body {
    position: relative;
    padding: 20px 10px;
  }

  .pop-input {
    font-size: 14px;
    border-radius: 8px;
    width: 75%;
    padding-left: 5px;
  }

  .btn-confirm {
    background: #7289da;
    color: #ffffff;
    border: 1px solid #7289da;
    border-radius: 12px;
    font-size: 14px;
    width: 70px;
    height: 28px;
    margin-right: 12.5px;
  }

  .btn-confirm:hover{
    background: #818fc0;
    border: #818fc0;
  }

  .btn-confirm:focus {
    outline: 0;
  }  
  
  .btn-cancel {
    background: #eb675e;
    color: #ffffff;
    border: 1px solid #eb675e;
    border-radius: 12px;
    font-size: 14px;
    width: 70px;
    height: 28px;
    margin-left: 12.5px;
  }

  .btn-cancel:hover {
    background: #e98f88;
    border: #e98f88;
  }

  .btn-cancel:focus {
    outline: 0;
  }  

  .pop-fade-enter,
  .pop-fade-leave-active {
    opacity: 0;
  }

  .pop-fade-enter-active,
  .pop-fade-leave-active {
    transition: opacity .5s ease
  }

  .splash-container {
    background: #36393f;
    color: #f8f8f8;
    font-size: 14px;
    border-radius: 8px;
    box-shadow: 0.5px 0.5px 5px 0.25px #656769;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 256px;
    height: 176px;
    position: relative;
  }

  .splash {
    margin: 0 auto;
    position: absolute;
    top: 50%; left: 50%;
    transform: translate(-50%,-50%);
  }
  

  .splash-content {
    width: 88px;
    height: 88px;
    margin: 0 auto;
    border: 3px solid #7289da;
    border: 3px solid transparent;
    border-top-color: #7289da;
    border-bottom-color: #7289da;
    border-radius: 50%;
    -webkit-animation: loader 2s linear infinite;
    -moz-animation: loader 2s linear infinite;
    -o-animation: loader 2s linear infinite;
    animation: loader 2s linear infinite;
  }

  @keyframes loader {
    0% {
      -webkit-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>